import React from 'react'
import Header from './Header'
const Home = () => (
  <div>
    <section className="hero is-blue-gem-2 is-fullheight is-bold">
      <Header />
      <div className="hero-body">
        <div className="container">
          <h1 className="title">
            Park Park Go
          </h1>
          <h2 className="subtitle">
            Parking made easy
          </h2>
        </div>
      </div>
    </section>
    <section className="hero is-medium is-lavender is-bold">
      <div className="hero-body">
        <div className="container">
          <h1 className="title">
            How does it work?
          </h1>
          <h2 className="subtitle">
            We gather all the park spots provider in one single place.
          </h2>
        </div>
      </div>
    </section>
    <section className="hero is-blue-gem is-medium is-bold">
      <div className="hero-body">
        <div className="container">
          <h1 className="title">
            Are you a parking business owner?
          </h1>
          <h2 className="subtitle">
            Sign up!
          </h2>
        </div>
      </div>
    </section>
  </div>
)

export default Home



// WEBPACK FOOTER //
// ./src/components/Home.js